/*
 * Motion Effects — reveals natively lazy-loaded images once they have
 * actually finished loading, so the CSS skeleton/shimmer (motion-effects.css)
 * can fade out smoothly instead of using an arbitrary timer.
 *
 * Design notes:
 * - Only ever ADDS a class ("motion-loaded"). It never hides an image or
 *   changes markup/attributes, so it cannot break lazy loading, sliders,
 *   carousels, quick-add, or variant image swapping.
 * - Uses a capture-phase "load" listener on `document` (the "load" event does
 *   not bubble) so it also catches images that are added to the DOM later
 *   (e.g. quick-add modal, variant media swaps) without needing a
 *   MutationObserver.
 * - Includes a safety net: if for any reason an image's load event is missed,
 *   it is still revealed after window load, so an image can never be stuck
 *   permanently invisible.
 */
(function () {
  'use strict';

  function markLoaded(img) {
    if (img && img.tagName === 'IMG') {
      img.classList.add('motion-loaded');
    }
  }

  // Catch every image load, including ones added to the DOM after this runs.
  document.addEventListener(
    'load',
    function (event) {
      var target = event.target;
      if (target && target.tagName === 'IMG' && target.getAttribute('loading') === 'lazy') {
        markLoaded(target);
      }
    },
    true
  );

  // Catch images that were already loaded/cached before the listener above
  // was attached (e.g. from the browser image cache).
  function revealCached() {
    var images = document.querySelectorAll('img[loading="lazy"]:not(.motion-loaded)');
    for (var i = 0; i < images.length; i++) {
      var img = images[i];
      if (img.complete && img.naturalWidth > 0) {
        markLoaded(img);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', revealCached);
  } else {
    revealCached();
  }

  // Safety net: never leave an image permanently hidden.
  window.addEventListener('load', function () {
    setTimeout(function () {
      var images = document.querySelectorAll('img[loading="lazy"]:not(.motion-loaded)');
      for (var i = 0; i < images.length; i++) {
        markLoaded(images[i]);
      }
    }, 2000);
  });
})();
